import type { DeviceComponent } from '../deviceComponentApi'
import { demoApi } from './db'

export const deviceComponentApi = {
	getDeviceComponents: async (deviceId: string): Promise<DeviceComponent[]> =>
		demoApi.get(`/v1/devices/${deviceId}/components`),
	createDeviceComponent: async (component: Pick<DeviceComponent, 'name'>): Promise<DeviceComponent> =>
		demoApi.post('/v1/device_components', component),
	updateDeviceComponent: async (
		componentId: string,
		component: Pick<DeviceComponent, 'name'>,
	): Promise<DeviceComponent> => demoApi.put(`/v1/device_components/${encodeURIComponent(componentId)}`, component),
	deleteDeviceComponent: async (componentId: string): Promise<void> =>
		demoApi.delete(`/v1/device_components/${encodeURIComponent(componentId)}`),
}
